export const environment = {
  production: false,
  apiEndpoint: 'https://pama-dev.digital.studia.fr/pama',
  webService: {
    url: '/pama',
    api: '/api',
    server: 'https://pama-dev.digital.studia.fr'
    //server: 'http://localhost:8080'
  },
  keycloak: {
    url: 'https://sso.dev.digital.studia.fr',
    realm: 'PamaDev',
    clientId: 'pama'
  },
  pagination: {
    limit: 25,
    offset: 0
  },
  version: '1.8',
  features: {
    validation_en_saisie: false,
    menu_aide: false
  },
  menu_aide: {
    url: 'https://youtu.be/cBlsWue2Ssc'
  },
  lien_accueil: {
    dhesa: 'https://dhesa-dev.studia.fr/',
    neoged: 'https://demo.neoged.com/neoged/',
    pama: '/pama/recrutement',
    telios: 'https://telios-demo.telino.net/TeliosWeb/#',
    magitel: 'https://magitel-cl-nocert.telino.fr/portail/main/np_home.php'
  }
};
